import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hrefExternal',
  standalone: false
})
export class HrefExternalPipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) {
      return '';
    }

    return /^https?:\/\//i.test(value) ? value : `//${value}`;
  }
}
